export enum MERCHANT_STATUS {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  INACTIVE = 'inactive',
  UNSIGNED = 'unsigned',
  UNREGISTERED = 'unregistered',
}
